module.exports = __webpack_public_path__ + "img/records-failure-en.8c8e0b72.png";